module.exports = __webpack_public_path__ + "static/media/video-detail-polygon.48077c35.png";